export default "__VITE_ASSET__f773b716__"